import { Box, Link } from "@mui/joy";
import { OpenInNewIcon } from "../../../styles/StyledMUI";
import type { TrainingCourse } from "../../../api/training/Training.typed";
import { colorTokens, textTokens } from "../../../styles/globalStyles";

interface TrainingDocsProps {
  courses: TrainingCourse[] | undefined;
}

export default function TrainingDocs(props: TrainingDocsProps) {
  return (
    <Box sx={{ padding: 1, display: "flex", justifyContent: "center" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25, alignItems: "center" }}>
        {(props.courses || []).map((course) =>
          course?.Url ? (
            <Link
              key={course.ID}
              href={course.Url}
              target="_blank"
              rel="noopener"
              startDecorator={<OpenInNewIcon sx={{ fontSize: 18 }} />}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.25,
                py: 0.75,
                borderRadius: 9999,
                textDecoration: "none",
                color: textTokens.color.secondary,
                bgcolor: colorTokens.bg.surface,
                border: `1px solid ${colorTokens.border.default}`,
                transition: "all .15s ease",
                "&:hover": {
                  bgcolor: colorTokens.bg.surfaceElevated,
                  borderColor: colorTokens.border.strong,
                  transform: "translateY(-1px)",
                  textDecoration: "none",
                },
              }}
            >
              {course.Name || "Document"}
            </Link>
          ) : null,
        )}
      </Box>
    </Box>
  );
}
